import React, { useEffect, useRef, useState } from 'react';
import { cn, copyToClipboard } from '../../../utils/utils';

import { ReactComponent as EditSvg } from '../../../assets/svgs/edit.svg';
import { ReactComponent as DownloadSvg } from '../../../assets/svgs/download.svg';
import { ReactComponent as ShareSvg } from '../../../assets/svgs/share.svg';
import SvgCom from '../../../components/SvgCom/index.jsx';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';

const VideoCardCom = ({ className ='', detailInfo }) => {
  const videoRef = useRef(null);
  const nvigate = useNavigate();
  const [timeStr, setTimeStr] = useState('00:00');
  useEffect(() => {
    const fnTest = () => {
      const seconds = videoRef.current.duration;
      const timerStr = moment.utc(seconds * 1000).format('mm:ss');
      setTimeStr(timerStr);
    };
    if(videoRef && videoRef.current) {
      videoRef.current.addEventListener('loadedmetadata', fnTest);
    }
    return () => {
      if(videoRef.current) {
        videoRef.current.removeEventListener('loadedmetadata', fnTest);
      }
    };
  }, [videoRef]);

  const rowBtnClick = async(e, type) => {
    e.stopPropagation();
    const id = detailInfo.id;
    if(type === 'share') {
      try {
        const host = window.location.host;
        await copyToClipboard(`${host}/consumer-theatre-processing/showreel/detail/${id}`);
        message.success('Copid');
      } catch(error) {
        //
      }
    } else if(type === 'download') {
      //
    } else if(type === 'edit') {
      //
      nvigate(`/consumer-theatre-processing/showreel/detail/${id}/edit`);
    }
  };
  return (
    <div className={cn('bg-[#DFECDD] rounded-2xl p-[15px]', className)} onClick={() => nvigate(`/consumer-theatre-processing/showreel/detail/${detailInfo?.id}`)}>
      <div className="flex items-center justify-between mb-2">
        <span className="text-base font-bold leading-none text-green-1">{detailInfo?.title}</span>
        <div className="py-[6px] px-[12px] text-[10px] leading-none rounded-lg bg-primary text-white">{detailInfo?.status}</div>
      </div>
      <div className="flex items-center justify-between text-xs leading-none text-green-1 mb-2.5">
        <span>Created {moment(detailInfo?.created_at).format('YYYY/MM/DD')}</span>
        <span className="mr-[12px]">Videos {detailInfo?.items_count}</span>
      </div>
      <div className="h-[265px] rounded-md relative overflow-hidden">
        <video ref={videoRef} src={detailInfo.video_url} className="w-full h-full" controls autoPlay={false}></video>
        {/* <div className="absolute w-full h-full top-0 left-0 flex justify-center items-center cursor-pointer">
          <img src={pauseIcon} alt="" className="w-[22px] h-[30px]" />
        </div> */}
        <div className="absolute bottom-3 right-3 px-2 py-1 rounded text-white text-[10px] bg-[#00A32E61]">
          {timeStr}
        </div>
      </div>
      <div className="mt-[13px] flex items-center justify-end">
        <SvgCom onClick={(e) => rowBtnClick(e, 'edit')} Svg={EditSvg} size="16" className="ml-4 cursor-pointer text-green-1 hover:text-primary"></SvgCom>
        <SvgCom onClick={(e) => rowBtnClick(e, 'download')} Svg={DownloadSvg} size="16" className="ml-4 cursor-pointer text-green-1 hover:text-primary"></SvgCom>
        <SvgCom onClick={(e) => rowBtnClick(e, 'share')} Svg={ShareSvg} size="16" className="ml-4 cursor-pointer text-green-1 hover:text-primary"></SvgCom>
      </div>
    </div>
  );
};

export default VideoCardCom;